export const PANEL_TITLE_CLASS_NAME = 'm-0 text-[1.375rem] font-medium leading-normal text-balance text-text-primary';
